"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { SimpleCarousel } from "../../component/SimpleCarousel/SimpleCarousel";
import { InlineMediaPanel } from "../../component/InlineMediaPanel/InlineMediaPanel";
interface InlineMediaCarouselViewProps {
  panels: InlineMediaPanel[];
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
}
export const InlineMediaCarouselView = t0 => {
  const $ = _c(11);
  const {
    panels,
    componentImagePriority,
    isLCP: t1
  } = t0;
  const isLCP = t1 === undefined ? false : t1;
  const [activeSlide, setActiveSlide] = useState(0);
  let t2;
  if ($[0] !== activeSlide || $[1] !== componentImagePriority || $[2] !== isLCP || $[3] !== panels) {
    let t3;
    if ($[5] !== activeSlide || $[6] !== componentImagePriority || $[7] !== isLCP) {
      t3 = (item, index) => <div key={`carousel-panel-${item.id}-${index}`} className="px-0.5"><InlineMediaPanel {...item} displayMode="carousel" isActiveSlide={index === activeSlide} componentImagePriority={componentImagePriority} isLCP={isLCP} /></div>;
      $[5] = activeSlide;
      $[6] = componentImagePriority;
      $[7] = isLCP;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = panels.map(t3);
    $[0] = activeSlide;
    $[1] = componentImagePriority;
    $[2] = isLCP;
    $[3] = panels;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <SimpleCarousel onSlideChange={setActiveSlide}>{t2}</SimpleCarousel>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};